<template>
  <div class="shops_list_item">
    <div class="shop_title">{{ name }}</div>
    <div class="shop_subway" v-if="metroName">{{ metroName }}</div>
    <div class="shop_adress" ><template v-if="cityName">{{ cityName }} </template>{{ address }}</div>
    <div>
      <span class="shop_phone">
        {{ phone }}
        <template v-if="phoneExt">{{ phoneExt }}</template>
      </span>
      <span class="shop_working_hours">{{ workingTime }}</span>
    </div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      required: false
    },
    metroName: String,
    cityName: String,
    address: {
      type: String,
      required: false
    },
    phone: {
      type: String,
      required: false
    },
    phoneExt: String,
    workingTime: {
      type: String,
      required: false
    },
  },
};
</script>
